<template>
  <div id="app">
    <div v-if="isLoggedIn">
      <Loading v-if="mainLoading"/>
      <organization-map v-else-if="originalHostName()"></organization-map>
      <Admin v-else-if="isLoggedIn && !originalHostName() && !forceUpdatePassword"/>
      <ForceUpdatePassword v-else-if="forceUpdatePassword"/>
      <!-- <div v-else>You don't have access to this url</div> -->
      <!-- <Login v-else/> -->
      <VersionFooter />
    </div>
    <div v-else>
      <Login />
    </div>
    <RealEstateDropZonePreview/>
    <WebSocketVue/>
  </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {MAIN_LOADING} from '@/store';
    import Loading from '@/views/Loading';
    import OrganizationMap from '@/views/map/OrganizationMap';
    // import Login from '@/views/Login';
    import Admin from '@/views/Admin';
    import Login from '@/views/Login';
    import RealEstateDropZonePreview from '@/views/real-estate/RealEstateDropZonePreview';
    import WebSocketVue from '@/views/websocket/WebSocketConfig.vue'
    import VersionFooter from "@/components/layout/VersionFooter.vue";
    import ForceUpdatePassword from "@/views/profile/ForceUpdatePassword.vue";

    export default {
        metaInfo: {
            title: 'Электрон бахолаш',
            titleTemplate: '%s | Мулкларингизни бахолаш',
            htmlAttrs: {
                reptilian: 'gator'
            },
            headAttrs: {
                nest: 'eggs'
            },
            meta: [
                { charset: 'utf-8' },
                { name: 'description', content: 'Электрон бахолаш Ушбу сайт орқали сиз кўчар ва кўчмас мулкларингизни онлайн тарзда баҳолатишни амалга оширишингиз мумкин' },
                { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
        },
        components: {
          ForceUpdatePassword,
          VersionFooter,
            Loading,
            // Login,
            Admin,
            RealEstateDropZonePreview,
            OrganizationMap,
            WebSocketVue,
            Login
        },
        computed: {
            ...mapState(['mainLoading', 'isLoggedIn', 'hostName', 'profile', 'loginMethod']),
            forceUpdatePassword() {
              return this.profile.forceUpdatePassword
            }
        },
        methods: {
            originalHostName() {
                const url = this.hostName;
                if (url) {
                    var parts = url.split('://');
                    if (parts.length > 1) {
                        const baseUrl = parts[1].split('/')[0];
                        // console.log(baseUrl);
                        if (baseUrl==='e-baholash.uz' || baseUrl.includes('127.0.0.1')){
                            return true;
                        }
                    }
                }
                return false;
            }
        },
        created() {
            this.$store.commit(MAIN_LOADING, true);
            if (!this.isLoggedIn) {
              this.$store.dispatch('initProfile', true);
            }
        }
    }
</script>

<style>
</style>
